import React from "react";
import { styled } from "../../../styles";
import { TileTitle, TileFact, Glass } from "../../../components";
import { ProjectInterface } from "../../ProjectPage";

interface IProps {
  project: ProjectInterface;
  ar?: number;
}

export const ProjectTile: React.SFC<IProps> = ({ project }) => {
  // console.log({project})
  const filteredFacts = [
    ...project.facts.slice(0, 2),
    ...(project.facts.length > 2 ? project.facts.slice(-1) : [])
  ];

  return (
    <TileContainer src={project.thumbnail.url}>
      <TileAwards>
        {project.awards.length > 0 &&
          project.awards.map(awardName => {
            try {
              const awardUrl = require(`../assets/awards/${awardName
                .toLowerCase()
                .replace(" ", "_")}.svg`);

              return <img src={awardUrl} alt={awardName} key={awardName} />;
            } catch (e) {
              console.error(e);

              return null;
            }
          })}
      </TileAwards>

      <TileTitle>
        <Glass>{project.title}</Glass>
      </TileTitle>

      {filteredFacts.slice(0, 3).map(fact => (
        <TileFact key={`${project.slug}-${fact.type}`}>
          <Glass>
            {fact.type} <strong>{fact.name}</strong>
          </Glass>
        </TileFact>
      ))}
    </TileContainer>
  );
};

const TileContainer = styled.div<{ src: string }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding: 1.4rem 1rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-image: ${({ src }: { src: string }) => `url(${src})`};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  will-change: transform;
`;

const TileAwards = styled.div`
  flex: 1;
  align-self: flex-end;
  margin-left: auto;

  img {
    width: 48px;
    height: auto;
  }
`;
